"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Caret = void 0;
var icons_1 = require("../../../../../icons");
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var styled_components_1 = __importDefault(require("styled-components"));
var mixins_1 = require("../../../../../themes/mixins");
var themes_1 = require("../../../../themes");
var CaretDown = icons_1.icons.CaretDown;
var StyledCaretDown = (0, styled_components_1.default)(CaretDown)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  transform: ", ";\n"], ["\n  ", "\n  transform: ", ";\n"])), (0, mixins_1.transition)("transform"), function (_a) {
    var showOptions = _a.showOptions;
    return showOptions ? "rotate(180deg)" : "rotate(0deg)";
});
var Caret = function (_a) {
    var showOptions = _a.showOptions, disabled = _a.disabled;
    return (react_1.default.createElement(styled_1.StyledCaret, null,
        react_1.default.createElement(StyledCaretDown, { size: 16, color: disabled ? themes_1.colors.grey40 : themes_1.colors.grey80, weight: "bold", showOptions: showOptions }),
        react_1.default.createElement(styled_1.StyledCaretClickArea, null)));
};
exports.Caret = Caret;
var templateObject_1;
